var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',{staticClass:"pcs"},[_c('PcsBanner',{attrs:{"dataimgs":_vm.dataimgs}}),_vm._v(" "),_c('BannerBottom',{attrs:{"data":_vm.bannerBottomItems}}),_vm._v(" "),_c('IntroPCS',{attrs:{"data":_vm.intros}}),_vm._v(" "),_c('ScenePCS',{attrs:{"data":_vm.scenes}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76e1954e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/fastclass-loader!./src/components/PortalPCS.vue
// module id = null
// module chunks = 